// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","Root":"Root_PUP7T","Label":"Label_m1KDf"};